// src/components/home/Features.tsx
import React from 'react';

interface Duty {
    no: string;
    title: string;
    body: string;
}

const DUTIES: Duty[] = [
    {
        no: 'N-01',
        title: 'Vahetused ja väljakutsed',
        body: 'Käi patrullis, lahenda väljakutseid ja teeni palka. Mida kõrgem auaste, ' +
            'seda vastutusrikkamad ülesanded ja parem tasu.'
    },
    {
        no: 'N-02',
        title: 'Treening ja koolitused',
        body: 'Arenda jõudu, vastupidavust, kiirust ja taipu. Läbi koolitusi ja soorita ' +
            'eksameid, et avada uusi ametikohti ja oskusi.'
    },
    {
        no: 'N-03',
        // Until 55.64 this promised group and unit leadership, which left the game with the
        // department; it is kept as content for the career ladder above patrol (ROADMAP).
        title: 'Piirkond ja edetabel',
        body: 'Vali prefektuur ja jaoskond, kus teenistust pead, kauple teiste ametnikega turul ' +
            'ning tõuse oma maailma edetabelis teistest ette.'
    },
    {
        no: 'N-04',
        title: 'Elu väljaspool tööd',
        body: 'Osta krunt ja ehita sinna kodu materjalidest, mida ise metsas, kaevanduses ja ' +
            'sepikojas tood või turult ostad. Proovi õnne kasiinos ja hoia teenitu pangas.'
    }
];

/**
 * The duty list renders plainly, with no scroll-triggered reveal.
 *
 * An earlier version started these at opacity 0 and waited for an
 * IntersectionObserver. That is a bad trade for a landing page: when the reveal
 * does not run, the content is not merely un-animated, it is gone. It went out
 * that way once already.
 */
export const Features: React.FC = () => (
    <section className="lp-section" id="mang">
        <div className="lp-shell">
            <div className="lp-section__head">
                <p className="lp-eyebrow">
                    <span className="lp-eyebrow__dot" />
                    Teenistuskäik
                </p>
                <h2 className="lp-section__title">Mida sa mängus teed</h2>
            </div>

            <div className="lp-duty">
                {DUTIES.map((duty) => (
                    <article className="lp-duty__item" key={duty.no}>
                        <span className="lp-duty__no">{duty.no}</span>
                        <h3 className="lp-duty__title">{duty.title}</h3>
                        <p className="lp-duty__body">{duty.body}</p>
                    </article>
                ))}
            </div>
        </div>
    </section>
);
